const INSTALLED_KEY = Symbol("INSTALLED_KEY");

export { INSTALLED_KEY };
//# sourceMappingURL=key.mjs.map
